<template>
  <div class="modal-block fade popup-img">
    <div class="modal-dialog message-modal">
      <div class="modal-content" v-if="d_arguments" style="background-color: #60BDD3;">        
        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>        -->
		<img alt="image" :src="d_arguments.Image">
		<br />
		<br />
        <div class="modal-content-block" > 
          <!-- Info de kilometros disponibles -->
          <template v-if="d_arguments.idMsg == 1"><h6 style="color: white;">HOLA {{ d_arguments.memberName.toUpperCase() }} TENES <strong>{{ d_arguments.memberKms }} PUNTOS</strong> YPF SERVICLUB DISPONIBLES PARA EL CANJE DE ENTRADAS O CANDYS.</h6></template>
        </div>
        <button class="info-btn yellow">ACEPTAR</button>
      </div>
    </div>	
  </div>
</template>

<script>
	require("./../assets/jquery.bpopup.min.js");

	export default {
		name: "popupimage",
		data: function() {
			return {				
				d_arguments: null
			};
		},
		computed:{			
		},
		methods: {
			m_open: function(args) {				
				this.d_arguments = args;				

				$(this.$el).bPopup({
					positionStyle: "fixed",
					closeClass: "popup-close, .info-btn",
					onOpen: function() { 
						this.reposition();
					}
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/PopupImage.vue